var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CreateUser',{attrs:{"Header":"สร้างผู้ใช้งาน"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }